import useSize from 'ahooks/lib/useSize';

const COL_SIZE = {
    lg: 'lg',
    md: 'md',
    sm: 'sm',
};

export default ref => {
    const dom = ref?.current || document.querySelector('body');
    const { width } = useSize(dom) || {};
    let size = COL_SIZE.lg;
    if (width >= 1370) {
        size = COL_SIZE.lg;
    } else if (width >= 992) {
        size = COL_SIZE.md;
    } else {
        size = COL_SIZE.sm;
    }
    return size;
};
